import React, { useState, Fragment,useEffect } from 'react'
import { Icon,Placeholder, Card } from 'semantic-ui-react'
import { Typography,Button,createMuiTheme,useMediaQuery } from '@material-ui/core';
import CSS from './Details.module.css';
import {deleteVendor } from '../../Store/Action';
import {connect} from 'react-redux';

function Details(props) {

  const theme= createMuiTheme({
    breakpoints : {
      values : {
        xs : 426
      }
    }
  })

  const isMatch= useMediaQuery(theme.breakpoints.up("xs"))

  const [loading, setLoading] = useState(false)

  const onload = () => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 2000);
  }

  useEffect(() => {
    onload()
    
  }, [])

  const vendorDelete=()=>{
    props.deleteAction(props.Dets)
    props.initials()
  }

  return (
    <div className={`container pb-2 ${CSS.container}`}>
        <Card fluid className="pb-3 pt-3" >
        <Card.Content>
          <Card.Header textAlign="center" >
            {(loading) ? (
              <Typography variant="h3">
                <Placeholder >
                  <Placeholder.Header>
                    <Placeholder.Line />
                  </Placeholder.Header>
                </Placeholder>
              </Typography>)
              :
              (
                <Typography variant="h4">
                    {props.Dets.cName}
                </Typography>
              )}

          </Card.Header>
          <Card.Meta className="mt-4">
            <Typography variant="h5">
              {loading ?
                (<Placeholder >
                  <Placeholder.Header>
                    <Placeholder.Line length="short" />
                  </Placeholder.Header>
                </Placeholder>)
                :
                props.Dets.fullName
              }
            </Typography>
          </Card.Meta>
              
          <Card.Description className="mt-2">
            { !isMatch ? 
            <Typography variant="body1">

            {loading ? (<Placeholder >
              <Placeholder.Header>
                <Placeholder.Line  />
              </Placeholder.Header>
            </Placeholder>) :   
                <div>
                <Typography color="textSecondary" className="mb-3" variant="subtitle1" align="left">
                 {props.Dets.address}
                </Typography>
                <Icon size="large" name="mail" />
                  {props.Dets.email}
                  <br/>
                  <br/>
                <Icon size="large"  name="phone" rotated="clockwise" />
                  {props.Dets.number}
              </div>  
              }
          </Typography> 
          : 
          <Typography variant="body1">

            {loading ? (<Placeholder >
              <Placeholder.Header>
                <Placeholder.Line  />
              </Placeholder.Header>
            </Placeholder>) :   
                <div className="mb-3 mt-4">
                <Typography color="textSecondary" className="mb-4" variant="subtitle1" align="left">
                 {props.Dets.address}
                </Typography>
                <Icon size="large" name="mail" />
                  {props.Dets.email}
                <Icon style={{ marginLeft: '1.5rem' }} size="large" name="phone" rotated="clockwise" />
                  {props.Dets.number}
              </div>  
              }
          </Typography> 
            }
            
          </Card.Description>

        </Card.Content>
     
          <Card.Content extra>
            {
              loading ? (<Placeholder >
                <Placeholder.Header>
                  <Placeholder.Line />
                </Placeholder.Header>
              </Placeholder>) :
                (
                  <div className="text-center">
                      {
                      props.otpSuccess ?
                      <Fragment> 
                      <Button onClick={props.edit} variant="outlined" style={{marginRight : '1rem'}} color='primary'>
                        Edit
                      </Button>
                      <Button onClick={vendorDelete} variant="outlined" color='secondary'>
                        Delete
                      </Button>
                      </Fragment> 
                      :
                      <Fragment>
                      <Typography variant="body1">
                        Enter otp to edit your details
                      </Typography>   
                      <Typography variant="body2">
                      Note:- you won't be able to change the service. To change the service
                      delete your account and register as new vendor.
                    </Typography>
                    </Fragment>   
                    }

                  </div>
                )

            }
          </Card.Content>
      </Card>    
        
    </div>
  )
}

const mapStateToProps=state=>({
  state_data : state.user  
})

const mapDispatchToProps=({
  deleteAction : deleteVendor
})

export default connect(mapStateToProps,mapDispatchToProps)(Details)
